import { TFiltersActions } from '../../actions/filters';
import { EDatesModalActionType } from '../../actions/filters/datesModal';
import { IDatesModalState } from '../../types/filters/datesModal';

export const defaultState: IDatesModalState = {
  isOpen: false,
  skipAutoOpen: false,
};

export function datesModalReducer(state = defaultState, action: TFiltersActions): IDatesModalState {
  switch (action.type) {
    case EDatesModalActionType.Open:
      return {
        ...state,
        isOpen: true,
      };
    case EDatesModalActionType.Close:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}
